import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function OnboardingTiendanube() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const params = new URLSearchParams();
    params.set('returnTo', 'tiendanube');
    if (token) {
      params.set('legacyToken', token);
    }
    navigate(`/login?${params.toString()}`, { replace: true });
  }, [navigate, searchParams]);

  return null;
}
